import { Loadable } from '../../Loadable';

export const AsyncAddFreedomPayConfig = Loadable(() => import('./Add'));
export const AsyncEditFreedomPayConfig = Loadable(() => import('./Edit'));
export const AsyncFreedomPayConfigList = Loadable(() => import('./List'));
